import type { Orientation } from './useResizeMobilePlay.utils';

/**
 * `playInfo.thumbnailRatio`("16:9", "3:4" 등)를 파싱해 가로/세로를 판별한다.
 * - 빈 문자열 또는 파싱 불가 → `null` (호출 측에서 setVideoAspect 스킵)
 * - 정사각형(1:1)은 기존 정책 유지 차원에서 portrait 처리
 */
export function resolveThumbnailRatioAspect(thumbnailRatio: string): Orientation | null {
  if (!thumbnailRatio) return null;

  const [wRaw, hRaw] = thumbnailRatio.split(':');
  const width = Number(wRaw);
  const height = Number(hRaw);

  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }

  return width > height ? 'landscape' : 'portrait';
}
